import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { PackageSecurityServerAssignmentGridDataProviderFactory } from '../factory/PackageSecurityServerAssignmentGridDataProviderFactory';
import { PackageSecurityServerAssignmentGridSchema } from '../types';
import { PackageSecurityServerAssignmentGridDataProvider } from '../dataProvider/PackageSecurityServerAssignmentGridDataProvider';

export class PackageSecurityServerAssignmentGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PackageSecurityServerAssignmentGridDataProviderFactory;
  public dataProvider: PackageSecurityServerAssignmentGridDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PackageSecurityServerAssignmentGridDataProviderFactory(),
    });
  }

  public async getDataForView(companyId: string): Promise<PackageSecurityServerAssignmentGridSchema> {
    return this.dataProvider.getDataForView(companyId);
  }

  public async updateSVAMachines(records: Array<PackageSecurityServerAssignmentGridSchema>): Promise<boolean> {
    return this.dataProvider.updateSVAMachines(records);
  }
}
